import { MenuList } from '@reach/menu-button';
import React from 'react';

import './AccountMenuList.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const AccountMenuList: React.FC<Props> = ({ children, className }) => {
  return (
    <MenuList className={`AccountMenuList ${className}`}>{children}</MenuList>
  );
};
